import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
var DeviceRuntimeReportsView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceRuntimeReportsView, _super);
    function DeviceRuntimeReportsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.charts = [];
        _this.bestValues = null;
        _this.reportMessage = "";
        _this.filters = {
            startDate: "",
            endDate: ""
        };
        return _this;
    }
    Object.defineProperty(DeviceRuntimeReportsView.prototype, "selectedCharts", {
        get: function () {
            return !this.charts
                ? []
                : this.charts.filter(function (c) { return c.active; });
        },
        enumerable: true,
        configurable: true
    });
    DeviceRuntimeReportsView.prototype.mounted = function () {
        this.setCharts();
        this.setDefaultFilters();
        this.reportMessage = this.$t("deviceRuntimeReports.searching").toString();
        this.getBestValues();
        this.$watch("filters.startDate", this.getBestValues);
        this.$watch("filters.endDate", this.getBestValues);
    };
    DeviceRuntimeReportsView.prototype.setDefaultFilters = function () {
        var now = new Date();
        this.filters.endDate = now.toISOString().split('T')[0];
        var startDate = new Date(now);
        startDate.setFullYear(now.getFullYear() - 1);
        this.filters.startDate = startDate.toISOString().split('T')[0];
    };
    DeviceRuntimeReportsView.prototype.getBestValues = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bestValues;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.get("devicesensorlog/beststatics", { params: { serialNumber: this.device.serial, startDay: this.filters.startDate, endDay: this.filters.endDate } })];
                    case 1:
                        bestValues = (_a.sent()).data;
                        this.bestValues = bestValues;
                        if (this.bestValues) {
                            if (bestValues.length == 3) {
                                bestValues[0].title = this.$t("deviceRuntimeReports.rowMonth").toString();
                                bestValues[1].title = this.$t("deviceRuntimeReports.rowWeek").toString();
                                bestValues[2].title = this.$t("deviceRuntimeReports.rowDay").toString();
                            }
                        }
                        else {
                            this.reportMessage = this.$t("deviceRuntimeReports.noData").toString();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DeviceRuntimeReportsView.prototype.setCharts = function () {
        this.charts = [];
        this.charts.push({
            title: this.$t("deviceRuntimeReports.cumulativeUsage").toString(),
            type: "line",
            active: false,
            options: this.getDefaultOptionsWithLabels("deviceRuntimeReports.legendTimeDay", "deviceRuntimeReports.legendRuntimeHour"),
            url: 'devicesensorlog/hourintakecumulative'
        });
        this.charts.push({
            title: this.$t("deviceRuntimeReports.usagePerDay").toString(),
            type: "bar",
            active: false,
            options: this.getDefaultOptionsWithLabels("deviceRuntimeReports.legendTimeDay", "deviceRuntimeReports.legendRuntimeHour"),
            url: 'devicesensorlog/hourintakeday'
        });
        this.charts.push({
            title: this.$t("deviceRuntimeReports.usagePerWeek").toString(),
            type: "bar",
            active: false,
            options: this.getDefaultOptionsWithLabels("deviceRuntimeReports.legendTimeWeek", "deviceRuntimeReports.legendRuntimeHour"),
            url: 'devicesensorlog/hourintakeweek'
        });
        this.charts.push({
            title: this.$t("deviceRuntimeReports.usagePerMonth").toString(),
            type: "bar",
            active: false,
            options: this.getDefaultOptionsWithLabels("deviceRuntimeReports.legendTimeMonth", "deviceRuntimeReports.legendRuntimeHour"),
            url: 'devicesensorlog/hourintakemonth'
        });
        this.charts.push({
            title: this.$t("deviceRuntimeReports.usagePerDayAverage").toString(),
            type: "bar",
            active: false,
            options: this.getDefaultOptionsWithLabels("deviceRuntimeReports.legendTimeDayOfWeek", "deviceRuntimeReports.legendRuntimeHour"),
            url: 'devicesensorlog/dayaverage'
        });
        this.charts.push({
            title: this.$t("deviceRuntimeReports.assetByCalender").toString(),
            type: "line",
            active: false,
            options: this.getDefaultOptionsWithLabels("deviceRuntimeReports.legendTimeDay", "deviceRuntimeReports.legendRuntimePercent"),
            url: 'devicesensorlog/assetbycalender'
        });
        this.charts.push({
            title: this.$t("deviceRuntimeReports.assetByWorkTime").toString(),
            type: "line",
            active: false,
            options: this.getDefaultOptionsWithLabels("deviceRuntimeReports.legendTimeDay", "deviceRuntimeReports.legendRuntimePercent"),
            url: 'devicesensorlog/assetbyworktime'
        });
        this.charts.push({
            title: this.$t("deviceRuntimeReports.temperaturePerWeek").toString(),
            type: "bar",
            active: false,
            options: this.getDefaultOptionsWithLabels("deviceRuntimeReports.legendTimeWeek", "deviceRuntimeReports.legendTemperatureWeek"),
            url: 'devicesensorlog/weektemperature'
        });
        this.charts.push({
            title: this.$t("deviceRuntimeReports.batteryLevelPerDay").toString(),
            type: "line",
            active: false,
            options: this.getDefaultOptionsWithLabels("deviceRuntimeReports.legendTimeDay", "deviceRuntimeReports.legendBatteryLevel"),
            url: 'devicesensorlog/batterylevel'
        });
    };
    DeviceRuntimeReportsView.prototype.getDefaultOptionsWithLabels = function (xAxisLabelKey, yAxisLabelKey) {
        return {
            scales: {
                yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: this.$t(yAxisLabelKey).toString()
                        }
                    }],
                xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: this.$t(xAxisLabelKey).toString()
                        }
                    }]
            }
        };
    };
    Object.defineProperty(DeviceRuntimeReportsView.prototype, "params", {
        get: function () {
            return { serialNumber: this.device.serial, startDay: this.filters.startDate, endDay: this.filters.endDate };
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceRuntimeReportsView.prototype, "device", void 0);
    DeviceRuntimeReportsView = tslib_1.__decorate([
        Component
    ], DeviceRuntimeReportsView);
    return DeviceRuntimeReportsView;
}(Vue));
export default DeviceRuntimeReportsView;
